const invertedMessages = {};

export default invertedMessages;
